module.exports = __webpack_public_path__ + "static/media/progman_34.f9472587.ico";